import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { FieldProps } from "formik";
import React from "react";
import { IBaseInput } from "./types";
import get from "lodash.get";
import InputMask from "react-input-mask";
import OptimisedField from "./optimisedField";

interface IDateInput extends InputProps, IBaseInput {
  name: string;
  type?: undefined; // prevent setting the `type` prop
}

const DateInput: React.FC<IDateInput> = (props) => {
  const { name, label, optimise, isRequired, isDisabled, ...rest } = props;
  return (
    <OptimisedField optimise={optimise} name={name}>
      {(fieldProps: FieldProps<string>) => {
        const { form, field } = fieldProps;
        const error = get(form.errors, name);
        const isInvalid = !!error && !!get(form.touched, name);

        return (
          <FormControl
            isInvalid={isInvalid}
            isRequired={isRequired}
            isDisabled={isDisabled}
          >
            <FormLabel htmlFor={name}>{label}</FormLabel>
            <Input
              as={InputMask}
              mask="** / ** / ****"
              type="tel" // "number" isn't compatible with `InputMask` - https://github.com/sanniassin/react-input-mask/issues/110
              {...rest}
              {...field}
              onChange={(e) => {
                let value: string | undefined = e.target.value;
                // clear empty value to improve 'required' validation UX
                if (value === "__ / __ / ____") {
                  value = undefined;
                }
                form.setFieldValue(field.name, value?.replaceAll(" ", ""));
              }}
            />
            <FormErrorMessage>{error}</FormErrorMessage>
          </FormControl>
        );
      }}
    </OptimisedField>
  );
};

export default DateInput;
